export default __webpack_public_path__ + "static/media/avatar-jan.0be6e798.png";